import { Component, input, output } from '@angular/core';
import { WarningConfirmDialog } from '../../../shared/components/warning-confirm-dialog/warning-confirm-dialog';

/**
 * Logout confirmation warning hosted in the app shell profile menu (OM-720).
 */
@Component({
  selector: 'app-logout-confirmation-dialog',
  imports: [WarningConfirmDialog],
  template: `
    <app-warning-confirm-dialog
      [open]="open()"
      modalClass="logout-confirmation-dialog"
      titleKey="layout.logoutConfirm.title"
      bodyKey="layout.logoutConfirm.body"
      cancelKey="layout.logoutConfirm.staySignedIn"
      confirmKey="layout.logoutConfirm.confirmLogout"
      (cancelled)="cancelled.emit()"
      (confirmed)="confirmed.emit()"
    />
  `,
  styleUrl: './logout-confirmation-dialog.scss',
})
export class LogoutConfirmationDialog {
  readonly open = input(false);
  readonly cancelled = output<void>();
  readonly confirmed = output<void>();
}
